import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';

function Navbar() {
  const location = useLocation();

  return (
    <nav className="bg-gradient-to-r from-violet-900 via-purple-900 to-fuchsia-900 shadow-xl sticky top-0 z-50 border-b border-purple-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-3 group">
            <Logo className="group-hover:scale-110 transition-transform duration-300" />
            <span className="text-xl font-bold bg-gradient-to-r from-pink-300 via-purple-300 to-violet-300 bg-clip-text text-transparent group-hover:from-pink-200 group-hover:via-purple-200 group-hover:to-violet-200 transition-all">
              CryptoVista
            </span>
          </Link>
          <ul className="flex space-x-1 sm:space-x-4">
            <li>
              <Link
                to="/"
                className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                  location.pathname === '/'
                    ? 'bg-gradient-to-r from-pink-500 to-purple-600 text-white shadow-lg'
                    : 'text-purple-200 hover:bg-purple-800 hover:text-white'
                }`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                  location.pathname === '/about'
                    ? 'bg-gradient-to-r from-pink-500 to-purple-600 text-white shadow-lg'
                    : 'text-purple-200 hover:bg-purple-800 hover:text-white'
                }`}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/faq"
                className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                  location.pathname === '/faq'
                    ? 'bg-gradient-to-r from-pink-500 to-purple-600 text-white shadow-lg'
                    : 'text-purple-200 hover:bg-purple-800 hover:text-white'
                }`}
              >
                FAQ
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                  location.pathname === '/contact'
                    ? 'bg-gradient-to-r from-pink-500 to-purple-600 text-white shadow-lg'
                    : 'text-purple-200 hover:bg-purple-800 hover:text-white'
                }`}
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
